import Form from './Form';
import List from './List';
import {ReceptacleDialog} from '../../../app/Manager/Client/Cart/Detail';

const Components = {
    Form : Form,
    List : List,
    Receptacles : ReceptacleDialog
}

export default Components;